import { createSVG } from "./svg_utils";

export default class Arrow {
  constructor(gantt, from_task, to_task) {
    this.gantt = gantt;
    this.from_task = from_task;
    this.to_task = to_task;

    this.calculate_path();
    this.draw();
  }

  calculate_path() {
    const start_x = this.from_task.$bar.getX() + this.from_task.$bar.getWidth();
    const start_y = this.from_task.$bar.getY() + this.gantt.options.bar_height;

    const end_x = this.to_task.$bar.getX() - this.gantt.options.padding / 2;
    const end_y = this.to_task.$bar.getY() + this.gantt.options.bar_height;

    const from_is_below_to = this.from_task.task._index > this.to_task.task._index;
    const curve = this.gantt.options.arrow_curve;
    const clockwise = from_is_below_to ? 1 : 0;
    const curve_y = from_is_below_to ? -curve : curve;
    const offset = from_is_below_to ? end_y + this.gantt.options.arrow_curve : end_y - this.gantt.options.arrow_curve;
    const right = start_x + (end_x - start_x) / 2 - curve;

    this.path = `
            M ${start_x} ${start_y}
            H ${right}
            a ${curve} ${curve} 0 0 ${from_is_below_to ? 0 : 1} ${curve} ${from_is_below_to ? -curve : curve}
            V ${offset}
            a ${curve} ${curve} 0 0 ${clockwise} ${curve} ${curve_y}
            L ${end_x} ${end_y}
            m -5 -5
            l 5 5
            l -5 5`;

    if (end_x - start_x < curve) {
      const down_1 = start_y + (end_y - start_y) / 2 - curve;
      const down_2 = this.to_task.$bar.getY() + this.to_task.$bar.getHeight() - curve_y;
      const left = this.to_task.$bar.getX() - this.gantt.options.padding - this.gantt.options.arrow_curve;

      this.path = `
                M ${start_x} ${start_y}
                h ${curve}
                a ${curve} ${curve} 0 0 ${from_is_below_to ? 0 : 1} ${curve} ${from_is_below_to ? -curve : curve}
                V ${down_1}
                a ${curve} ${curve} 0 0 ${from_is_below_to ? 0 : 1} ${-curve} ${from_is_below_to ? -curve : curve}
                H ${left}
                a ${curve} ${curve} 0 0 ${clockwise} -${curve} ${curve_y}
                V ${down_2}
                a ${curve} ${curve} 0 0 ${clockwise} ${curve} ${curve_y}
                L ${end_x} ${end_y}
                m -${curve} -${curve}
                l ${curve} ${curve}
                l -${curve} ${curve}
                `;
    }
  }

  draw() {
    this.element = createSVG("path", {
      d: this.path,
      "data-from": this.from_task.task.id,
      "data-to": this.to_task.task.id,
    });
  }

  update() {
    this.calculate_path();
    this.element.setAttribute("d", this.path);
  }
}
